import { deleteObjective } from '../../api/objective/objective.api';
import { useMutation } from 'react-query';
import {
  Button,
  Dialog,
  DialogActions,
  DialogContent,
  DialogContentText,
  DialogTitle
} from '@material-ui/core';
import { useTranslation } from 'react-i18next';

const DeleteObjectiveModal = ({ open, onClose, objective, onSuccess }) => {
  const { t } = useTranslation();

  const mutation = useMutation(async () => {
    await deleteObjective(objective.id);
  }, {
    onSuccess: () => {
      onSuccess?.();
      onClose();
    }
  });

  return <Dialog open={ open } onClose={ onClose }>
    <DialogTitle>
      <i>{objective.name}</i> - {t('objective.dialog.delete.title')}
    </DialogTitle>
    <DialogContent>
      <DialogContentText>{t('objective.alert.deleteConfirmation')}</DialogContentText>
    </DialogContent>
    <DialogActions>
      <Button onClick={ mutation.mutate } color='primary' variant='contained'>
        { t('objective.dialog.save') }
      </Button>
      <Button onClick={ onClose } color='primary'>
        { t('objective.dialog.cancel') }
      </Button>
    </DialogActions>
  </Dialog>;
};

export default DeleteObjectiveModal;